import appStore from './zh-CN/app-store';
import applicationCatalog from './zh-CN/application-catalog';
import applicationCenter from './zh-CN/application-center';
import applicationFeedback from './zh-CN/application-feedback';
import businessAppMarket from './zh-CN/business-app-market';
import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import markets from './zh-CN/markets';
import menu from './zh-CN/menu';
import myApps from './zh-CN/my-apps';
import navigation from './zh-CN/navigation';
import pages from './zh-CN/pages';
import platformSettings from './zh-CN/platform-settings';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import system from './zh-CN/system';
import workbench from './zh-CN/workbench';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.footer.copyright': '2026 珊瑚智成（北京）科技有限公司',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.workbench.link.fetch-blocks': '获取全部区块',
  'app.workbench.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...system,
  ...navigation,
  ...workbench,
  ...applicationCatalog,
  ...applicationCenter,
  ...applicationFeedback,
  ...businessAppMarket,
  ...markets,
  ...myApps,
  ...appStore,
  ...platformSettings,
};
